export default "__VITE_ASSET__Cqmha0Te__"